import { IResponse, IResponsePagination } from '@/types/common';
import {
  ICreateChatFukumaruRequest,
  IGetListChatFukumaruRequest,
  IUpdateChatFukumaruRequest,
} from '@/types/request/chatFukumaru';
import { IGetListChatFukumaruResponse } from '@/types/response/chatFukumaru';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class ChatFukumaru {
  getList = (
    params: IGetListChatFukumaruRequest,
  ): Promise<IResponsePagination<IGetListChatFukumaruResponse>> => {
    return axiosClient.get(ENDPOINT.CHAT_FUKUMARU.GET_LIST, { params: params });
  };

  delete = (id: number) => {
    return axiosClient.delete(
      ENDPOINT.CHAT_FUKUMARU.DELETE.replace(':id', String(id)),
    );
  };

  create = (body: ICreateChatFukumaruRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.CHAT_FUKUMARU.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<any>> => {
    return axiosClient.get(
      ENDPOINT.CHAT_FUKUMARU.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (
    data: IUpdateChatFukumaruRequest,
    id: number,
  ): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.CHAT_FUKUMARU.UPDATE.replace(':id', String(id)),
      data,
    );
  };
}

export const ChatFukumaruService = new ChatFukumaru();

